var map = {
	"./converge.png": 315,
	"./img-1.png": 22,
	"./img-2.png": 23,
	"./img-3.png": 24,
	"./img-4.png": 316,
	"./img-5.png": 21,
	"./img-6.gif": 317,
	"./logo_64264.png": 318,
	"./paradise_challenge.png": 319,
	"./pbpLogo_transparentBg.png": 320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos ^\.\/.*$
// module id = 314
// module chunks = 2